import ServiceBase from "base/baseService"

export default class MotivoDesoneraIcmsService extends ServiceBase {

    title = "Motivo de desoneração do ICMS"
    pluralTitle = "Motivos de desoneração do ICMS"
    url = '/cadastro/fiscal/motivodesonera_icms'
    frontUrl = '/cadastro/fiscal/motivodesonera_icms'
    frontUrlList = '/cadastro/fiscal/motivodesonera_icmslist'
    primaryKey = 'codigo_modi'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.descricao_modi = data?.descricao_modi || ''
        data.sigla_modi = data?.sigla_modi || ''

        return data
    }

    prepareToSave({ data }) {

        return data

    }

}
